import { Controller } from "@hotwired/stimulus";

// Usage: data-controller="dismiss" data-dismiss-timeout-value="6000"
export default class extends Controller {
  static values = { timeout: { type: Number, default: 5000 } }

  connect() {
    if (this.timeoutValue > 0) {
      this._timer = setTimeout(() => this.remove(), this.timeoutValue)
    }
  }

  disconnect() {
    if (this._timer) clearTimeout(this._timer)
  }

  remove() {
    if (this.element) {
      this.element.classList.add('opacity-0', 'translate-y-[0px]')
      setTimeout(() => this.element.remove(), 150)
    }
  }
}
